import {TipoEntitaOrganizzativa} from '../../+configurazione/tipoentitaorganizzativa/tipoentitaorganizzativa.model';
import {Period} from '../../common/model/period.model';
import {Indirizzo} from '../entitalocale/indirizzo.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {TableRow} from '../../common/model/table-row.model';
import {Select2Template} from '../../common/template/select2-template';
import {Carattere} from './carattere.enum';
import { EntitaLocale } from '../entitalocale/entitalocale.model';
import { ValoreAttributo } from '../../common/model/valoreattributo.model';
import { FasciaEntitaOrganizzativa } from '../fasciaentitaorganizzativa/fasciaentitaorganizzativa.model';

export class EntitaOrganizzativa extends Period {

  constructor(protected id: number,
                public denominazione: string,
                public denominazioneBreve: string,
                public sigla: string,
                public idnsip: string,
                public cdsuo: string,
                public inizioValidita: string,
                public fineValidita: string,
                public carattere: Carattere,
                public tipo: TipoEntitaOrganizzativa,
                public indirizzoPrincipale: Indirizzo,
                public entitaLocaleId: number,
                public email: string,
                public pec: string,
                public sitoweb: string,
                public telefono: string,
                public telefono2: string,
                public telefono3: string,
                public fax: string,
                public sedeRiferimento: boolean,
                public valoreAttributoWebDtos: ValoreAttributo[] = undefined,
                public fasceAppartenenza: FasciaEntitaOrganizzativa[] = undefined,
                public validDateForFascia: string = undefined
  ) {
    super(id, inizioValidita, fineValidita);
  }

  public static getTableKeys() {
    return ['denominazione', 'sigla', 'comune', 'idnsip', 'cdsuo'];
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('sigla', new TableRowValue(this.sigla, null));
    rowValues.set('denominazione', new TableRowValue(this, Select2Template.entitaOrganizzativaRow));
    rowValues.set('idnsip', new TableRowValue(this.idnsip, null));
    rowValues.set('comune', new TableRowValue(this.indirizzoPrincipale ? this.indirizzoPrincipale.getLabelComune() : null, null));
    rowValues.set('cdsuo', new TableRowValue(this.cdsuo, null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    return this.idnsip ? this.idnsip + ' - ' + this.denominazione : this.denominazione;
  }

  public getSigla() {
    let separator = '';
    let label = '';
    if (this.sigla && this.indirizzoPrincipale) {
      separator = ' - ';
    }
    if (this.sigla) {
      label = label + this.sigla;
    }
    if (!this.indirizzoPrincipale) {
      return label;
    }
    label = label + separator + this.indirizzoPrincipale.getLabelComune();
    return label;
  }


  public isDepartment() {
    return this.tipo.getId() === TipoEntitaOrganizzativa.DIPARTIMENTO;
  }

  public isInstitute() {
    return this.tipo.getId() === TipoEntitaOrganizzativa.ISTITUTO;
  }

  public isRsu() {
    return this.tipo.getId() === TipoEntitaOrganizzativa.RSU;
  }

  public isLivelloPadreSedi() {
    return this.tipo.getCategorie() && 
      this.tipo.getCategorie().filter( categoria => {
        return categoria.sigla === TipoEntitaOrganizzativa.LIVELLO_PADRE_SEDI;
      }).length !== 0;
  }

  public getLabelIndirizzoPrincipale(entitaLocale: EntitaLocale): string {
    var descIndirizzo = new Array();
    if (entitaLocale!==null && entitaLocale!==undefined && entitaLocale.descr!==null && entitaLocale.descr!==undefined) 
      descIndirizzo = descIndirizzo.concat(entitaLocale.descr);
    if (this.indirizzoPrincipale!==null &&  this.indirizzoPrincipale!==undefined) 
      descIndirizzo = descIndirizzo.concat(this.indirizzoPrincipale.getLabel() );
    return descIndirizzo.join(" - ");
  }

  public getLabelCurrentFascia(): string {
    if (this.validDateForFascia!==null && this.validDateForFascia!==undefined) {
      const fasce = this.fasceAppartenenza.filter(fasciaEo=>fasciaEo.belongToPeriod(new Date(this.validDateForFascia)));
      if (fasce.length>0)
        return fasce[0].fascia.getLabel();
    }
    return undefined;
  }
}

